import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR,FormControl } from '@angular/forms';
//import { environment } from 'environments/environment';
@Component({
	selector: 'phone-number',
	templateUrl: './phone-number.component.html',
	styleUrls: ['./phone-number.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PhoneNumberComponent),
			multi: true
		},	
		// {
		// 	provide: NG_VALIDATORS,
		// 	useExisting: forwardRef(() => PhoneNumberComponent),
		// 	multi: true,
		// }
	]
})

export class PhoneNumberComponent implements ControlValueAccessor, OnInit {
	placeholderVisible = true;
	@Input('value') _value: string = '';
	@Input() mobileOnly: boolean;
	@Input() isMobile: boolean;
	@Input() customClass: string = '';
	@Output() isMobileChange: EventEmitter<any> = new EventEmitter<any>();

	onChange: any = () => { };
	onTouched: any = () => { };
	currentNumber = '';
	
	currentPre = null;
	defaultValue="";

	// stationryPrefixes = environment.app.stationryPrefixes;//["02","03", "04", "08", "09", "071", "072", "073", "074", "076", "077", "079"]
	// mobilePrefixes = environment.app.mobilePrefixes;//["050", "052", "054", "056", "057", "058", "059"];
	stationryPrefixes = ["02","03", "04", "08", "09", "071", "072", "073", "074", "076", "077", "079"]
	mobilePrefixes = ["050", "051", "052", "053", "054", "055", "056", "057", "058", "059"]
	//stationryPrefixes = [{key:"בחר",value:""},{key:"02",value:"02"},{key:"02",value:"03"}, {key:"04",value:"04"}, {key:"08",value:"08"}, {key:"09",value:"09"}, {key:"071",value:"071"}, {key:"072",value:"072"}, {key:"073",value:"073"}, {key:"074",value:"074"}, {key:"076",value:"076"}, {key:"077",value:"077"}, {key:"079",value:"079"}]
	//mobilePrefixes = [{key:"בחר",value:""},{key:"050",value:"050"}, {key:"052",value:"052"}, {key:"053",value:"053"}, {key:"054",value:"054"}, {key:"056",value:"056"}, {key:"057",value:"057"}, {key:"058",value:"058"}, {key:"059",value:"059"}]
  
	prefixes = [];
	private parseError: boolean;

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;

		this.onChange(val);
		this.onTouched();
	}

	registerOnChange(fn) {
		this.onChange = fn;
	}

	registerOnTouched(fn) {
		this.onTouched = fn;
	}

	writeValue(value) {
		if (value) {
			this.value = value;
			this.setPrefixAndNumber();
		}
	}

	propagateChange = (_: any) => { 

	};

	// public validate(c: FormControl) {
	// 	return (this.currentPre && this.currentNumber && (this.currentPre + this.currentNumber).length >=9 ) ? null : {
	// 		invalidPhoneNumber: true 
	// 		// inputError: {
	// 		// 	valid: false,
	// 		// },
	// 	};
	// }

	ngOnInit() {
		this.currentPre = this.defaultValue;
		this.prefixes = this.mobileOnly ? this.mobilePrefixes : this.stationryPrefixes.concat(this.mobilePrefixes)
		//this.currentPre = this.prefixes[0];

		if (this.value) {
			this.setPrefixAndNumber();
		}
	}
	

	setPrefixAndNumber() {
		let pre1 = this.value.toString().substring(0, 2);
		let pre2 = this.value.toString().substring(0, 3);

		let stationaryPre = this.stationryPrefixes.includes(pre1) ? pre1 : (this.stationryPrefixes.includes(pre2) ? pre2 : '')
		let mobilePre = this.mobilePrefixes.includes(pre2) ? pre2 : '';

		if (stationaryPre && !this.mobileOnly) {
			this.currentPre = stationaryPre;
			this.currentNumber = this.value.toString().substring(stationaryPre.length);
		} else if (mobilePre) {
			this.currentPre = mobilePre;
			this.currentNumber = this.value.toString().substring(mobilePre.length);
		} else {
			this.value = '';
		}
	}

	onKeyPressNumber(val, e) {
		var unicode = e.keyCode ? e.keyCode : e.charCode

		if (unicode >= 48 && unicode <= 57) {
			this.currentNumber = val;
			this.value = this.currentPre + this.currentNumber;
		} else {
			return false;
		}
	}

	onPreChange(val) {
		this.currentPre = val;
		this.value = this.currentPre + this.currentNumber;
		this.isMobile = this.mobilePrefixes.includes(val);
		this.isMobileChange.emit(this.isMobile);
		
		//console.log("#######>>>  this.isMobile = ",this.isMobile);
	}

	onChangeNumber(val) {
		this.currentNumber = val;
		this.value = this.currentPre + this.currentNumber;
	}

	onInnerTouched() {
		this.onTouched();
	}
}






// WEBPACK FOOTER //
// ./src/app/phone-number/phone-number.component.ts